import { render, staticRenderFns } from "./SupplierDetail.vue?vue&type=template&id=ba68595e&scoped=true&"
import script from "./SupplierDetail.vue?vue&type=script&lang=js&"
export * from "./SupplierDetail.vue?vue&type=script&lang=js&"
import style0 from "./SupplierDetail.vue?vue&type=style&index=0&id=ba68595e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba68595e",
  null
  
)

export default component.exports